
<template lang="pug">
.flex.items-center
  QDatetimeMod.select-date(
    v-bind="$attrs"
    :value="timestamp"
    format="YYYY年M月D日(ddd)"
    format-model="number"
    v-on="listeners"
  )

  template(v-if="buttons")
    q-btn(
      flat round dense
      :disable="prevTimestamp == null"
      @click="changed(prevTimestamp)"
    ) 前

    q-btn(
      flat round dense
      :disable="nextTimestamp == null"
      @click="changed(nextTimestamp)"
    ) 次

</template>

<script>
import {addDays, subDays, isValid} from 'date-fns/esm'

import {dateToObject, dateToString} from 'helpers/date'

import QDatetimeMod from 'components/QDatetimeMod'

export default {
  components: {QDatetimeMod},

  props: {
    value: {required: true},
    buttons: {type: Boolean, default: false},
  },

  computed: {
    listeners() {
      return {
        ...this.$listeners,
        input: timestamp => {this.inputted(timestamp)},
        change: timestamp => {this.changed(timestamp)},
      }
    },

    timestamp() {
      const date = dateToObject(this.value)
      return isValid(date) ? date.valueOf() : null
    },

    prevTimestamp() {
      const date = dateToObject(this.value)
      return isValid(date) ? subDays(date, 1).valueOf() : null
    },

    nextTimestamp() {
      const date = dateToObject(this.value)
      return isValid(date) ? addDays(date, 1).valueOf() : null
    },

    validValue() {
      let date = dateToObject(this.value)
      if(!isValid(date)) {
        date = dateToObject(this.$store.state.today)
      }
      return dateToString(date)
    },
  },

  watch: {
    validValue: {
      immediate: true,
      handler(value) {
        if(value !== this.value) {
          this.$emit('change', value)
        }
      },
    },
  },

  methods: {
    inputted(timestamp) {
      const date = new Date(timestamp)
      if(isValid(date)) {
        this.$emit('input', dateToString(date))
      }
    },

    changed(timestamp) {
      const date = new Date(timestamp)
      if(isValid(date)) {
        const value = dateToString(date)
        this.$emit('change', value)
      }
    },
  },
}
</script>

<style lang="sass">
.select-date
  width: 11rem
</style>
